<div class="cell auto" *ngIf="parameters">
    <kiwi-parameters-tab-content-header
        [saveDisabled]="areParametersReadonly()"
        (saved)="updateParameters()"
        [titleLabelKey]="'menu.parameters.ingredients.purchase.prices.title'">
    </kiwi-parameters-tab-content-header>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <p [i18nKey]="'menu.parameters.ingredients.purchase.prices.description'"></p>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <table class="_tableColor">
        <thead>
        <tr class="_titlePartTable">
            <th></th>
            <th style="text-align:center"><span [i18nKey]="'menu.parameters.ingredients.purchase.prices.standard.quality'"></span> 1</th>
            <th style="text-align:center"><span [i18nKey]="'menu.parameters.ingredients.purchase.prices.standard.quality'"></span> 2</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td [i18nKey]="'menu.parameters.ingredients.purchase.prices.first.course'"></td>
            <td>
                <kiwi-currency-input
                    [(ngModel)]="parameters.firstCoursesStandardPurchasingPrices['FIRST_COURSE_1']"
                    [disabled]="areParametersReadonly()">
                </kiwi-currency-input>
            </td>
            <td>
                <kiwi-currency-input
                    [(ngModel)]="parameters.firstCoursesStandardPurchasingPrices['FIRST_COURSE_2']"
                    [disabled]="areParametersReadonly()">
                </kiwi-currency-input>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'menu.parameters.ingredients.purchase.prices.fish'"></td>
            <td>
                <kiwi-currency-input
                    [(ngModel)]="parameters.mainCoursesStandardPurchasingPrices['FISH_1']"
                    [disabled]="areParametersReadonly()">
                </kiwi-currency-input>
            </td>
            <td>
                <kiwi-currency-input
                    [(ngModel)]="parameters.mainCoursesStandardPurchasingPrices['FISH_2']"
                    [disabled]="areParametersReadonly()">
                </kiwi-currency-input>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'menu.parameters.ingredients.purchase.prices.meat'"></td>
            <td>
                <kiwi-currency-input
                    [(ngModel)]="parameters.mainCoursesStandardPurchasingPrices['MEAT_1']"
                    [disabled]="areParametersReadonly()">
                </kiwi-currency-input>
            </td>
            <td>
                <kiwi-currency-input
                    [(ngModel)]="parameters.mainCoursesStandardPurchasingPrices['MEAT_2']"
                    [disabled]="areParametersReadonly()">
                </kiwi-currency-input>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'menu.parameters.ingredients.purchase.prices.dessert'"></td>
            <td>
                <kiwi-currency-input
                    [(ngModel)]="parameters.dessertsStandardPurchasingPrices['DESSERT_1']"
                    [disabled]="areParametersReadonly()">
                </kiwi-currency-input>
            </td>
            <td>
                <kiwi-currency-input
                    [(ngModel)]="parameters.dessertsStandardPurchasingPrices['DESSERT_2']"
                    [disabled]="areParametersReadonly()">
                </kiwi-currency-input>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'menu.parameters.ingredients.purchase.prices.wine'"></td>
            <td>
                <kiwi-currency-input
                    [(ngModel)]="parameters.winesStandardPurchasingPrices['WINE_1']"
                    [disabled]="areParametersReadonly()">
                </kiwi-currency-input>
            </td>
            <td>
                <kiwi-currency-input
                    [(ngModel)]="parameters.winesStandardPurchasingPrices['WINE_2']"
                    [disabled]="areParametersReadonly()">
                </kiwi-currency-input>
            </td>
        </tr>
        </tbody>
    </table>
</div>
